import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { LoadingIndicator } from 'common/components/preloader';
import { getProjectUrl } from 'project/utils';
import Meta from 'project/containers/meta';

/**
 * Accept collaboration invite screen.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class AcceptCollaborationInvite extends Component {
  componentDidMount() {
    const { accept, projectId, inviteId, inviteKey } = this.props;
    accept(projectId, inviteId, inviteKey);
  }

  render() {
    const { accepted, inviteProject } = this.props;
    const projectUrl = (
      inviteProject? getProjectUrl(inviteProject, inviteProject.sub_category.slug) : ''
    );

    return (
      <div className="l-content info-screen" id="content">
        <Meta title="Accept Collaboration Invite" />

        {accepted === undefined?
        <LoadingIndicator/>:
        <div className="row">
          <div className="columns medium-8 small-16">

            <h2>{accepted? 'Invitation Accepted':'Failed to Accept Invitation'}</h2>

            {accepted?
            <p>
              The invitation to collaborate on the project has been accepted.
              Click on the button below to go to the project.
            </p>:
            <p>
              For some reason, the invitation could not be accepted.
              Please get in touch via our <a>help center</a>.
            </p>}

            {/* Using an anchor tag here instead of <Link> because a full page reload
                is required since the user may have just been logged in. */}
            {accepted?
            <a href={projectUrl} className="btn btn-primary">Go to project</a>:
            <Link className="btn btn-primary" to="/help/contact/">Get in touch</Link>}

          </div>

          <div className="columns medium-8 small-16 icon hide-for-small-only">
            <i className={"fa fa-" + (accepted? "check-circle":"frown-o")}></i>
          </div>
        </div>}

      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {func} accept - accept invite
 * @property {string} projectId - project ID
 * @property {string} inviteId - invitation ID
 * @property {string} inviteKey - invitation key
 * @property {bool} accepted - whether invitation was accepted
 * @property {object} inviteProject - project for which invite was accepted
 */
AcceptCollaborationInvite.propTypes = {
  accept: PropTypes.func,
  projectId: PropTypes.string,
  inviteId: PropTypes.string,
  inviteKey: PropTypes.string,
  accepted: PropTypes.bool,
  inviteProject: PropTypes.object,
};



// WEBPACK FOOTER //
// ./project/components/accept_collaboration_invite.jsx